import React from "react";
import Layout from "../../../Layouts/Layout";

function OfferStats() {
  return (
    <Layout>
      <div className="px-4">Offers Stats</div>
    </Layout>
  );
}

export default OfferStats;
